<script lang="ts">
  import { preventDefault } from 'svelte/legacy';

    import EmailIcon from "$lib/icons/EmailIcon.svelte";
    import ForgotPassword from "$lib/icons/ForgotPassword.svelte";
    import EmailIconSupport from "$lib/icons/EmailIconSupport.svelte";
    import LIveChat from "$lib/icons/LIveChat.svelte";
    import {closeDialog} from "$lib/stores/dialogStores";
    import {onMount} from "svelte";
    import Button from "$lib/elements/Button.svelte";
    import {toasts} from "$lib/stores/toastStores";
    import {environment} from "$lib/env";
    import {translate} from "$lib/i18n";
    let apiUrl = environment.apiUrl;
    let liveChatReady = false;
    let email = $state('');
    let requestError: string | null = $state(null);
    let isLoading = $state(false);
    let isInputEmpty = $derived(email.trim() === '');

    onMount(() => {
        if (window.LiveChatWidget) {
            window.LiveChatWidget.on('ready', function () {
                liveChatReady = true;
            });
        } else {
            console.error('LiveChatWidget is not defined');
        }
    });

    function openChat() {
        if (liveChatReady) {
            window.LiveChatWidget.call('maximize');
        } else {
            console.error('LiveChat widget not ready yet');
        }
    }

    async function requestForgotPassword() {
        if (isInputEmpty) return;
        isLoading = true;
        requestError = null;
        try {
            const response = await fetch(`${apiUrl}/forgot-password/request`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email })
            });

            if (!response.ok) {
                if (response.status === 400) {
                    throw new Error('Invalid email address');
                } else if (response.status === 404) {
                    throw new Error('Email not found');
                } else {
                    throw new Error('Failed to send reset email');
                }
            }
            toasts.send('Password reset link sent successfully! Please check your email.', 'success')
            closeDialog('ForgotPasswordModal');
        } catch (error: any) {
            console.error('Request failed:', error);
            requestError = error.message || 'An unexpected error occurred';
        } finally {
            isLoading = false;
        }
    }
</script>
<div class="flex flex-col pt-2 gap-4">
  <h2 class="text-center mb-4 px-2 font-medium text-white">{$translate('Forgot your password?')}</h2>
  <div class="border-b border-b-primary-lightBlue -mb-[1px]"></div>
  <div class="px-6">
    <form onsubmit={preventDefault(requestForgotPassword)}>
      <div class="flex flex-col gap-4">
        <div class="flex flex-col items-center text-sm text-primary-lightBlue mb-2 pt-4 gap-6 font-medium ">
          <div class="bg-primary-lightBlue/40 p-3 rounded-full">
            <ForgotPassword/>
          </div>
          <p>{$translate('Enter your email address to get a password reset link.')}</p>
        </div>
        <div class="rounded-full bg-primary-dark w-full py-2.5 px-6 flex items-center">
          <EmailIcon />
          <input class="outline-0 w-full bg-transparent text-sm text-white placeholder-primary-lightBlue ml-2" type="email" placeholder="Enter your email" bind:value={email}/>
        </div>
        <div>
          {#if requestError}
            <div class="text-sm text-red-500 mt-2">{requestError}</div>
          {/if}
        </div>
        <div>
          <Button disabled={isInputEmpty} loading={isLoading} on:click={() => requestForgotPassword()} clas="w-full">{$translate('Reset password')}</Button>
        </div>
        <div class="flex items-center mt-4 justify-center text-sm text-primary-lightBlue gap-2">
          <p>{$translate('Do you remember your password?')}</p>
          <a class="cursor-pointer text-white" onclick={() => closeDialog('ForgotPasswordModal')}>Login</a>
        </div>
      </div>
    </form>
  </div>
  <div class="flex text-center p-3 mt-4 rounded-lg justify-center text-sm bg-primary-lightBlue/20">
    <div class="flex gap-5 justify-center">
      <div class="text-primary-lightBlue">
        <button class="flex gap-1.5" onclick={() => openChat()} id="openChatButton"><LIveChat/>{$translate('Live Chat')}</button>
      </div>
      <div class="text-primary-lightBlue">
        <a class="flex gap-1.5 " href="mailto:support@forza.bet"><EmailIconSupport/> support@forza.bet</a>
      </div>
    </div>
  </div>
</div>
